module.exports = __webpack_public_path__ + "media/scripts/pages/csr/assets/media/past-projects/addanewstory-ebc9747d99144bc7060689681215c6ae.jpg";